import { render, staticRenderFns } from "./pricenewCG.vue?vue&type=template&id=e64d7040&scoped=true"
import script from "./pricenewCG.vue?vue&type=script&lang=js"
export * from "./pricenewCG.vue?vue&type=script&lang=js"
import style0 from "./pricenewCG.vue?vue&type=style&index=0&id=e64d7040&prod&scoped=true&lang=css"
import style1 from "./pricenewCG.vue?vue&type=style&index=1&id=e64d7040&prod&lang=css"
import style2 from "./pricenewCG.vue?vue&type=style&index=2&id=e64d7040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d7040",
  null
  
)

export default component.exports